import { useMutation } from '@tanstack/react-query';
import { useBoundStore } from '@Store/index.ts';
import { updateCustomerName } from '@Services/init/partnerWelcome.api.ts';

export const useCustomerName = () => {
  const customerData = useBoundStore((state) => state.customer);
  const setCustomerData = useBoundStore((state) => state.setCustomerData);

  return useMutation({
    mutationFn: updateCustomerName,
    onSuccess: (_, variables) => {
      const updatedCustomerData = { ...customerData, ...variables };
      setCustomerData(updatedCustomerData);
    },
  });
};
